import image1 from "../../../images/tours/iceland/iceland1.jpg";
import image2 from "../../../images/tours/iceland/iceland2.jpg";
import image3 from "../../../images/tours/iceland/iceland3.jpg";
import image4 from "../../../images/tours/iceland/iceland4.jpg";
import image5 from "../../../images/tours/iceland/iceland5.jpg";
import image6 from "../../../images/tours/iceland/iceland6.jpg";
import React from "react";
import ImagesSection from "../common/ImagesSection";

const IcelandImagesSection = () => {

    const imageList = [
        {imageUrl: image1, text: 'iceland_img1'},
        {imageUrl: image2, text: 'iceland_img2'},
        {imageUrl: image3, text: 'iceland_img3'},
        {imageUrl: image4, text: 'iceland_img4'},
        {imageUrl: image5, text: 'iceland_img5'},
        {imageUrl: image6, text: 'iceland_img6'},
    ];

    return (
        <ImagesSection imageList={imageList}/>
    );
}

export default IcelandImagesSection;
